<template>
  <div>
    <el-row>
      <el-form
        class="search_form"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        :inline="true"
      >
        <el-col :span="3">
          <el-form-item prop="operatorId">
            <el-cascader
              size="mini"
              clearable
              ref="cascader"
              placeholder="运营商"
              :options="operatorsTree"
              :show-all-levels="false"
              :props="{ checkStrictly: true, expandTrigger: 'hover' }"
              change-on-select
              @change="handleChangeOperator"
              v-model="searchForm.operatorId"
            >
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item prop="stationId">
            <el-select placeholder="场站" v-model="searchForm.stationId">
              <el-option
                v-for="item in stationsForSelect"
                :key="item.id"
                v-bind:label="item.stationName"
                v-bind:value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item prop="pileId">
            <el-input
              placeholder="桩编号"
              v-model="searchForm.pileCode"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item prop="gunCode">
            <el-input
              placeholder="充电枪编号"
              v-model="searchForm.gunCode"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="3">
          <el-form-item prop="state">
            <el-form-item prop="state">
              <el-select placeholder="状态" v-model="searchForm.state">
                <el-option
                  v-for="item in enumData.stateData"
                  :key="item.value"
                  v-bind:label="item.message"
                  v-bind:value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item>
            <el-button size="mini" type="primary" @click="resetSearchForm"
              >清空</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="submitSearchForm"
              :loading="searchLoading"
              >查询
            </el-button>
          </el-form-item>
        </el-col>
      </el-form>
      <!--列表数据-->
      <el-table
        :data="gunDataTables"
        stripe
        style="width: 100%"
        ref="gunDataTable"
        border
        v-loading="listLoading"
      >
        <!--                <af-table-column type="selection" width="30"></af-table-column>-->
        <af-table-column prop="stationName" label="所属场站"></af-table-column>
        <af-table-column
          prop="gunName"
          label="枪名称"
          width="100"
        ></af-table-column>
        <af-table-column prop="gunCode" label="枪编号"></af-table-column>
        <!--        <af-table-column prop="pileCode" label="桩编号"></af-table-column>-->
        <!--        <af-table-column prop="operatorName" label="所属运营商"></af-table-column>-->
        <af-table-column width="110" label="枪工作状态">
          <template slot-scope="{ row }">
            <div v-if="row.state">
              <el-tag :type="row.state.code | stateFilter">
                {{ row.state.message }}
              </el-tag>
            </div>
          </template>
        </af-table-column>
        <af-table-column width="100" label="枪连接状态">
          <template slot-scope="{ row }">
            <div v-if="row.gunConnectionState">
              <el-tag
                :type="row.gunConnectionState.code | gunConnectionStateFilter"
              >
                {{ row.gunConnectionState.message }}
              </el-tag>
            </div>
          </template>
        </af-table-column>
        <af-table-column width="100" label="车连接状态">
          <template slot-scope="{ row }">
            <div v-if="row.carConnectionState">
              <el-tag
                :type="row.carConnectionState.code | carConnectionStateFilter"
                size="100"
              >
                {{ row.carConnectionState.message }}
              </el-tag>
            </div>
          </template>
        </af-table-column>
        <af-table-column label="二维码" width="90">
          <template slot-scope="{ row }">
            <el-popover
              placement="top"
              width="200"
              height="200"
              trigger="hover"
            >
              <img width="200" height="200" :src="row.qrCodeImg" />
              <div style="cursor: pointer" slot="reference">
                <div v-if="row.qrCodeImg">
                  <img width="20" height="20" src="static/image/e_code.png" />
                </div>
              </div>
            </el-popover>
          </template>
        </af-table-column>
        <af-table-column width="110" prop="canChargeTime" label="限制充电时段">
          <template slot-scope="scope">
            <div v-if="scope.row.canChargeTime">
              <span
                style="display: inline-block"
                v-for="(item, i) in JSON.parse(scope.row.canChargeTime)"
                :key="i"
              >
                {{ item[0] }} 至 {{ item[1] }}
              </span>
            </div>
          </template>
        </af-table-column>
        <af-table-column label="操作" width="600" fixed="right">
          <template slot-scope="scope">
            <el-popover
              v-if="checkPermission('bee:res:deviceControl:sendQrCode')"
              style="margin-right: 10px"
              placement="top"
              width="160"
            >
              <el-form
                class="sendQRCode"
                :model="sendQRCodeForm"
                ref="sendQRCodeForm"
                size="mini"
              >
                <el-col>
                  <el-form-item prop="qrCode">
                    <el-input
                      type="textarea"
                      placeholder="二维码"
                      v-model="sendQRCodeForm.qrCode"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item
                    hidden
                    label="id"
                    :label-width="formLabelWidth"
                    prop="id"
                  >
                    <el-input
                      v-model="sendQRCodeForm.id"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
              <div style="text-align: center">
                <!--                <el-button size="mini" @click="visible = false">关闭</el-button>-->
                <el-button
                  type="primary"
                  size="mini"
                  @click="sendQRCodeSubmit"
                  :loading="sendQRCodeSubmitLoading"
                  >下发</el-button
                >
              </div>
              <el-button
                slot="reference"
                size="mini"
                class="sendQRCode"
                plain
                @click="sendQRCode(scope.$index, scope.row)"
                >下发二维码
              </el-button>
            </el-popover>
            <!--              <el-button size="mini" class="sendQRCode" plain @click="sendQRCode(scope.$index, scope.row)">下发二维码-->
            <!--              </el-button>-->
            <el-popover
              style="margin-right: 10px"
              placement="top"
              width="160"
              v-if="checkPermission('bee:res:deviceControl:startCharge')"
            >
              <el-form
                class="remotelyStartUp"
                :model="remotelyStartUpForm"
                ref="remotelyStartUpForm"
                size="mini"
              >
                <p
                  style="
                    text-align: center;
                    background-color: white;
                    color: red;
                  "
                >
                  确定要启动<br /><span style="color: #2c3e50">{{
                    scope.row.gunCode
                  }}</span
                  >吗？
                </p>
                <el-col>
                  <el-form-item
                    hidden
                    label="id"
                    :label-width="formLabelWidth"
                    prop="id"
                  >
                    <el-input
                      v-model="remotelyStartUpForm.id"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
              <div style="text-align: center">
                <el-button
                  type="primary"
                  size="mini"
                  @click="remotelyStartUpSubmit(scope.row)"
                  :loading="remotelyStartUpSubmitLoading"
                  >启动</el-button
                >
              </div>
              <el-button
                slot="reference"
                size="mini"
                class="remotelyStartUp"
                plain
                @click="remotelyStartUp(scope.$index, scope.row)"
                >启动充电
              </el-button>
            </el-popover>
            <el-popover
              style="margin-right: 10px"
              placement="top"
              width="160"
              v-if="checkPermission('bee:res:deviceControl:remotelyStop')"
            >
              <el-form class="remotelyStop" ref="remotelyStopForm" size="mini">
                <p
                  style="
                    text-align: center;
                    background-color: white;
                    color: red;
                  "
                >
                  确定要停止<br /><span style="color: #2c3e50">{{
                    scope.row.gunCode
                  }}</span
                  >吗？
                </p>
              </el-form>
              <div style="text-align: center">
                <el-button
                  type="primary"
                  size="mini"
                  @click="remotelyStopSubmit(scope.row)"
                  :loading="remotelyStopSubmitLoading"
                  >停止充电</el-button
                >
              </div>
              <el-button
                slot="reference"
                size="mini"
                class="remotelyStop"
                plain
                @click="remotelyStop(scope.$index, scope.row)"
                >停止充电
              </el-button>
            </el-popover>
            <span v-if="scope.row.floorLockState.code > 0">
              <el-popover
                style="margin-right: 10px"
                placement="top"
                width="160"
                v-if="checkPermission('bee:res:deviceControl:lowerLock')"
              >
                <el-form class="remotelyStop" ref="lowerLockForm" size="mini">
                  <p
                    style="
                    text-align: center;
                    background-color: white;
                    color: red;
                  "
                  >
                    确定要操作<br /><span style="color: #2c3e50">{{
                    scope.row.gunCode
                  }}</span
                  >吗？
                  </p>
                </el-form>
                <div style="text-align: center">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="lowerLockSubmit(scope.row)"
                    :loading="lowerLockSubmitLoading"
                  >{{ scope.row.floorLockState.code == 85 ? "降锁" : "升锁" }}</el-button
                  >
                </div>
                <el-button
                  slot="reference"
                  size="mini"
                  class="remotelyStop"
                  plain
                  @click="lowerLock(scope.$index, scope.row)"
                >{{ scope.row.floorLockState.code ==  85 ? "降锁" : "升锁"  }}
                </el-button>
              </el-popover>
            </span>
            <el-popover
              style="margin-right: 10px"
              placement="top"
              width="160"
              v-if="checkPermission('bee:res:deviceControl:sendRate')"
            >
              <el-form
                class="sendRate"
                :model="sendRateForm"
                ref="sendRateForm"
                size="mini"
              >
                <el-col>
                  <el-form-item prop="vin">
                    <el-select
                      placeholder="选择费率"
                      v-model="sendRateForm.rateId"
                    >
                      <el-option
                        v-for="item in enumData.rateData"
                        :key="item.id"
                        v-bind:label="item.ruleName"
                        v-bind:value="item.id"
                      ></el-option>
                    </el-select>
                    <!--                    <el-input type="textarea" placeholder="选择费率" v-model="sendRateForm.rateId" clearable></el-input>-->
                  </el-form-item>
                </el-col>
              </el-form>
              <div style="text-align: center">
                <el-button
                  type="primary"
                  size="mini"
                  @click="sendRateSubmit(scope.row)"
                  :loading="sendRateSubmitLoading"
                  >下发</el-button
                >
              </div>
              <el-button
                slot="reference"
                size="mini"
                class="sendRate"
                plain
                @click="sendRate(scope.$index, scope.row)"
                >下发费率
              </el-button>
            </el-popover>
            <el-popover
              style="margin-right: 10px"
              placement="left"
              width="200"
              v-if="
                checkPermission(['bee:res:deviceControl:limitedTimeCharging'])
              "
            >
              <el-form
                class="limitedTimeCharging"
                :model="limitedTimeChargingForm"
                :rules="limitedTimeChargingFormRules"
                ref="limitedTimeChargingForm"
                size="mini"
              >
                <el-col>
                  <el-form-item prop="canChargeTime">
                    <el-col v-for="(item, i) in limitedTime" :key="i">
                      <el-time-select
                        class="limitedTimePicker"
                        placeholder="起始时间"
                        v-model="item[0]"
                        :picker-options="{
                          start: '00:00',
                          step: '00:10',
                          end: '24:00',
                          minTime:
                            i > 0 && limitedTime[i - 1][1]
                              ? limitedTime[i - 1][1].split(':')[0] +
                                ':' +
                                (limitedTime[i - 1][1].split(':')[1] - 1)
                              : '',
                        }"
                      ></el-time-select>
                      <el-time-select
                        class="limitedTimePicker"
                        placeholder="结束时间"
                        v-model="item[1]"
                        :picker-options="{
                          start: '00:00',
                          step: '00:10',
                          end: '24:00',
                          minTime: limitedTime[i][0],
                        }"
                      ></el-time-select>
                    </el-col>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item
                    hidden
                    label="id"
                    :label-width="formLabelWidth"
                    prop="id"
                  >
                    <el-input
                      v-model="limitedTimeChargingForm.id"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
              <div style="text-align: center">
                <el-button
                  type="success"
                  size="mini"
                  @click="addLimitedTimeCharging"
                  >添加</el-button
                >
                <el-button
                  type="danger"
                  size="mini"
                  @click="deleteLimitedTimeCharging"
                  >删除</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click="limitedTimeChargingSubmit(scope.$index, scope.row)"
                  :loading="limitedTimeChargingSubmitLoading"
                  >设置</el-button
                >
              </div>
              <el-button
                slot="reference"
                size="mini"
                class="limitedTimeCharging"
                plain
                @click="limitedTimeCharging(scope.$index, scope.row)"
                >限时充电
              </el-button>
            </el-popover>
          </template>
        </af-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination
        v-bind:child-msg="pageparam"
        @callFather="changePage"
      ></Pagination>
    </el-row>
  </div>
</template>

<script>
import Pagination from "@/module/operatingCenter/component/Pagination";
import gunApi from "../../../resourceCenter/api/gunApi";
import commonApi from "../../../resourceCenter/api/commonApi";
import deviceControlApi from "@/module/operatingCenter/api/deviceControlApi.js";
import commonApi2 from "@/common/api/commonApi.js";

let moment = require("moment");
export default {
  name: "gun",
  data() {
    return {
      stationsKey: 0,
      enumData: [
        {
          stateData: "",
          rateData: "",
        },
      ],
      stationsForSelect: "",
      operatorForSelect: "",
      operatorsTree: [],
      gunDataTables: [],
      pilesForSelect: "",
      searchLoading: false,
      searchForm: {
        // 未初始化不传递参数，影响后台接查询
      },
      listLoading: false,
      // 分页参数
      pageparam: {
        t: {},
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      formLabelWidth: "150px",
      sendQRCodeForm: {},
      sendQRCodeFormVisible: false,
      sendQRCodeSubmitLoading: false,
      remotelyStartUpForm: {},
      remotelyStartUpVisible: false,
      remotelyStartUpSubmitLoading: false,
      remotelyStopVisible: false,
      remotelyStopSubmitLoading: false,
      lowerLockSubmitLoading: false,
      sendRateForm: {},
      startChargeFrom: {},
      sendRateVisible: false,
      sendRateSubmitLoading: false,
      limitedTimeChargingForm: {},
      limitedTimeChargingVisible: false,
      limitedTimeChargingSubmitLoading: false,
      limitedTime: [["00:00", "24:00"]],
      limitedTimeChargingFormRules: {
        canChargeTime: [
          {
            require: true,
            message: "时间不能为空",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    resetSearchForm() {
      this.searchForm = {};
      this.submitSearchForm();
    },
    submitSearchForm() {
      this.searchLoading = true;
      this.listLoading = true;
      // let param = Object.assign({}, this.stationSearchForm)
      // para.date = (!para.date || para.date == '') ? '' : util.formatDate.format(new Date(para.date), 'yyyy-MM-dd');
      this.pageparam.t = this.searchForm;
      let param = Object.assign({}, this.pageparam);
      deviceControlApi.getGunsPageList(param).then((res) => {
        if (res.code === 0) {
          this.pageparam.total = res.data.total;
          this.gunDataTables = res.data.list;
          // this.$message({
          //   message: res.message,
          //   type: 'success'
          // })
        } else {
          this.$message.error(res.message);
        }
        this.searchLoading = false;
        this.listLoading = false;
      });
    },
    gunNumFormatter(cellValue) {
      return cellValue.gunNum + " 号枪";
    },
    changePage() {
      this.submitSearchForm();
    },
    // 加载下拉框
    loadSelectItem() {
      gunApi.getGunEnum().then((res) => {
        this.enumData.stateData = JSON.parse(res.stateData);
      });
    },
    loadForSelect() {
      // 站下拉框
      let operatorId = this.$store.getters.operatorIds;
      commonApi2.getStations().then((res) => {
        if (res.code === 0) {
          this.stationsForSelect = res.data;
        }
      });
      // 运营商下拉框
      commonApi.operatorSelectionList().then((res) => {
        if (res.code === 0) {
          this.operatorForSelect = res.data;
        }
      });
      // 运营商下拉框
      commonApi2.getOperatorsTree().then((res) => {
        if (res.code === 0) {
          this.operatorsTree = res.data;
        }
      });
      //费率下拉框
      gunApi.getRateSelectByOperatorId(operatorId).then((res) => {
        this.enumData.rateData = res;
      });
    },
    // 选中运营商
    handleChangeOperator(value) {
      let operatorId = value && value.length > 0 ? value[value.length - 1] : "";
      this.searchForm.operatorId = operatorId;
      this.$refs.cascader.dropDownVisible = false;
      // 获取该运营商下的对应站点
      commonApi.stationsForSelectByOperatorId([operatorId]).then((res) => {
        if (res.code === 0) {
          this.stationsForSelect = res.data;
        }
      });
    },
    sendQRCode(index, row) {
      this.sendQRCodeForm = {
        id: row.id,
        qrCode: row.qrCode,
      };
    },
    sendQRCodeSubmit() {
      this.$confirm("确认提交吗？", "提示", {}).then(() => {
        this.sendQRCodeSubmitLoading = true;
        this.listLoading = true;
        let param = JSON.stringify(this.sendQRCodeForm);
        gunApi
          .sendQRCode(param)
          .then((res) => {
            this.sendQRCodeSubmitLoading = false;
            this.listLoading = false;
            if (res.code === 0) {
              this.$message({
                message: res.message,
                type: "success",
              });
              this.submitSearchForm();
            } else {
              this.$message.error(res.message);
              this.sendQRCodeSubmitLoading = false;
              this.listLoading = false;
            }
          })
          .catch((error) => {
            this.sendQRCodeSubmitLoading = false;
            this.listLoading = false;
          });
      });
    },
    remotelyStartUp() {},
    remotelyStartUpSubmit(row) {
      this.remotelyStartUpSubmitLoading = true;
      this.listLoading = true;
      this.startChargeFrom.gunCode = row.gunCode;
      let param = JSON.stringify(this.startChargeFrom);
      deviceControlApi
        .getStartCharge(param)
        .then((res) => {
          this.remotelyStartUpSubmitLoading = false;
          this.listLoading = false;
          if (res.code === 0) {
            this.$message({
              message: res.message,
              type: "success",
            });
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((error) => {
          this.listLoading = false;
          this.remotelyStartUpSubmitLoading = false;
        });
    },
    remotelyStop() {},
    remotelyStopSubmit(row) {
      this.listLoading = true;
      this.remotelyStopSubmitLoading = true;
      gunApi
        .remotelyStop(row.gunCode)
        .then((res) => {
          this.listLoading = false;
          this.remotelyStopSubmitLoading = false;
          if (res.code === 0) {
            this.$message({
              type: "info",
              message: res.message,
            });
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((error) => {
          this.listLoading = false;
          this.remotelyStopSubmitLoading = false;
        });
    },
    lowerLockSubmit(row) {
      this.listLoading = true;
      this.lowerLockSubmitLoading = true;
      gunApi.lowerLock(row.gunCode)
        .then((res) => {
          this.listLoading = false;
          this.lowerLockSubmitLoading = false;
          if (res.code === 0) {
            this.$message({
              type: "info",
              message: res.message,
            });
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((error) => {
          this.listLoading = false;
          this.lowerLockSubmitLoading = false;
        });
    },
    lowerLock() {},
    sendRate(i, row) {
      // 	// if (row.state.message == "故障") {
      // 	// 	this.$message.error('充电枪非空闲状态，无法提供充电服务')
      // 	// 	return false
      // 	// }
      return true;
    },
    sendRateSubmit(row) {
      this.sendRateSubmitLoading = true;
      this.listLoading = true;
      this.sendRateForm.gunCode = row.gunCode;
      let param = JSON.stringify(this.sendRateForm);
      gunApi
        .sendRate(param)
        .then((res) => {
          this.listLoading = false;
          this.sendRateSubmitLoading = false;
          if (res.code === 0) {
            this.$message({
              type: "info",
              message: res.message,
            });
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((error) => {
          this.listLoading = false;
          this.sendRateSubmitLoading = false;
        });
    },
    limitedTimeCharging(index, row) {
      console.log(row.canChargeTime);
      if (row.canChargeTime == "" || row.canChargeTime == null) {
        this.limitedTime = [["00:00", "24:00"]];
      } else {
        this.limitedTime = JSON.parse(row.canChargeTime);
        console.log(this.limitedTime);
      }
    },
    limitedTimeChargingSubmit(index, row) {
      this.limitedTimeChargingForm = {
        id: row.id,
        canChargeTime: JSON.stringify(this.limitedTime),
      };
      let lt = this.limitedTime;
      let flag = false;
      let msg = "";
      for (var i = 0; i < lt.length; i++) {
        msg =
          lt[i][0] === null || lt[i][1] === null
            ? "设置限时时间段不能为空！"
            : "";
        if (msg !== "") {
          break;
        }
        for (var j = 0; j < lt.length; j++) {
          if (i != j) {
            flag =
              (lt[i][0] > lt[j][0] && lt[i][0] < lt[j][1]) ||
              (lt[i][1] > lt[j][0] && lt[i][1] < lt[j][1]);
            if (flag) {
              break;
            }
          }
        }
      }

      if (msg !== "" || flag) {
        this.$message.error(msg !== "" ? msg : "设置时间段重叠哦！");
        return;
      }
      this.$confirm("确认提交吗？", "提示", {}).then(() => {
        this.limitedTimeChargingSubmitLoading = true;
        let param = JSON.stringify(this.limitedTimeChargingForm);
        deviceControlApi.getLimitedTimeCharging(param).then((res) => {
          this.limitedTimeChargingSubmitLoading = false;
          if (res.code === 0) {
            this.$message({
              message: res.message,
              type: "success",
            });
            this.submitSearchForm();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    addLimitedTimeCharging() {
      let length = this.limitedTime.length;
      if (length < 4) {
        console.log("length:" + length);
        if (length > 0) {
          console.log(this.limitedTime[length - 1][1]);
          if (this.limitedTime[length - 1][1] != "24:00") {
            this.limitedTime.push([this.limitedTime[length - 1][1], "24:00"]);
          } else {
            this.$message.error("限时充电最晚时间已经是24:00了哦！");
          }
        } else {
          this.limitedTime.push(["00:00", "24:00"]);
        }
      } else {
        this.$message.error("不要添加太多");
      }
    },
    deleteLimitedTimeCharging() {
      this.limitedTime.splice(this.limitedTime.indexOf(["00:00", "24:00"]), 1);
    },
  },
  components: {
    Pagination,
  },
  created: function () {
    this.loadSelectItem();
    this.loadForSelect();
  },
  mounted: function () {
    this.submitSearchForm();
  },
  props: {
    gunDataTable: "",
  },
  filters: {
    stateFilter(state) {
      const statusMap = {
        0: "success", // 空闲
        1: "warning", //启动充电中
        2: "warning", //充电进行中
        3: "success", //充电结束
        4: "danger", //启动充电失败
        5: "danger", //预约充电中
        6: "info", //充电终端故障
      };
      return statusMap[state];
    },
    gunConnectionStateFilter(state) {
      if (state == null) {
        state = 1;
      }
      const statusMap = {
        0: "info", // 离线
        1: "success", //在线
      };
      return statusMap[state];
    },
    carConnectionStateFilter(state) {
      if (state == null) {
        state = 1;
      }
      const statusMap = {
        0: "info", // 断开
        1: "success", //连接
        2: "success", //半连接
      };
      return statusMap[state];
    },
  },
};
</script>

<style lang="less" scoped>
.el_search {
  background-color: teal;
  color: white;
}

.el_clear {
  background-color: darkorange;
  color: white;
}

.el-btn {
  /*float: right;*/
  margin-bottom: 15px;
}

/deep/ .search_form {
  .el-form-item__content {
    .el-input {
      width: auto;
    }
  }
}

/deep/ .edit_form,
/deep/ .detail_form {
  height: 400px;
  overflow: auto;

  .el-form-item__label {
    color: rgba(0, 0, 0, 0.47);
  }
}

.sendQRCode {
  background-color: #b2e042;
  color: white;
}

.remotelyStartUp {
  background-color: #1cbcff;
  color: white;
}

.remotelyStop {
  background-color: #d90600;
  color: white;
}

.sendRate {
  background-color: #12d900;
  color: white;
}

.servicePaused {
  background-color: #b91797;
  color: white;
}

.powerControl {
  background-color: #00a9b9;
  color: white;
}

.limitedTimeCharging {
  background-color: #d949c8;
  color: white;
}

/deep/.sendQRCodeForm {
  width: 100px;
  height: auto;
}

/deep/.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 96px;
}

.limitedTimePicker {
  width: 96px;
  margin-bottom: 2px;
}

.span_one {
  margin-right: 5px;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/module/operatingCenter/page/deviceControl/gun.vue